import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';
export { Spinner };
export const PageSpinner = (props) => {
    return (React.createElement(Flex, { top: 0, left: 0, right: 0, bottom: 0, position: "fixed", direction: "column", overflow: "hidden", alignItems: "center", justifyContent: "center", ...props },
        React.createElement(Spinner, { size: "xl", speed: "0.65s" })));
};
